import { render, staticRenderFns } from "./PostFooter.vue?vue&type=template&id=2be750f2&scoped=true"
import script from "./PostFooter.vue?vue&type=script&lang=js"
export * from "./PostFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be750f2",
  null
  
)

export default component.exports